import React, { useEffect } from 'react';
import { useParams, Navigate, Link } from 'react-router-dom';

/** Legacy WhatsApp task detail route — redirect to the ITSM ticket page. */
function TaskDetailPage() {
  const { taskNo } = useParams();

  useEffect(() => {
    // no-op: Navigate handles redirect
  }, [taskNo]);

  if (!taskNo) {
    return (
      <p style={{ color: '#6B7280', fontSize: '12px' }}>
        Missing ticket id. <Link to="/dashboard/whatsapp-tasks/inbox">Back to inbox</Link>
      </p>
    );
  }

  return <Navigate to={`/dashboard/tickets/list/${taskNo}`} replace />;
}

export default TaskDetailPage;
